import { moduleProviderFactory } from 'core/providers';
import { NikoOrderingDoctorList } from 'application/niko-ordering-doctor/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.niko-ordering-doctor',
                pattern: '/niko-ordering-doctor',
                children: [
                    {
                        name: 'master.app.main.niko-ordering-doctor.list',
                        pattern: '',
                        tabTitle: 'NIKO_ORDERING_DOCTOR.LIST.TITLE_SECONDARY',
                        component: NikoOrderingDoctorList,
                        data: {
                            title: 'NIKO_ORDERING_DOCTOR.LIST.TITLE_SECONDARY'
                        }
                    }                 
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.MASTER_DATA',
                order: 7,
                icon: 'database',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.NIKO_ORDERING_DOCTOR',
                        route: 'master.app.main.niko-ordering-doctor.list',
                        order: 9,
                    }
                ]
            }
        ]
    });
})();
